import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  SelfOnboardingActor,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.actor}selfonboarding/actor/details`;

interface GetSelfOnboardingActorsQueryPayload {
  sellerId?: string;
  fromTemplateSeller?: boolean;
  actorId?: string;
  actorSolutionRuleId?: string;
  siteActorRuleId?: string;
}

async function getSelfOnboardingActorsQuery({
  sellerId,
  fromTemplateSeller,
  actorId,
  actorSolutionRuleId,
  siteActorRuleId,
}: GetSelfOnboardingActorsQueryPayload): Promise<
  BackResponse<SelfOnboardingActor> | BackResponseFailure
> {
  try {
    const url = buildUrl(ENDPOINT, {
      sellerId,
      fromTemplateSeller,
      actorId,
      actorSolutionRuleId,
      siteActorRuleId,
    });

    const response = await apiCall<BackResponse<SelfOnboardingActor>>(url, {
      method: SUPPORTED_METHODS.GET,
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default getSelfOnboardingActorsQuery;
